import { render } from "./PdpProductHeader.vue?vue&type=template&id=2153a45f"
import script from "./PdpProductHeader.vue?vue&type=script&lang=js"
export * from "./PdpProductHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__